{ "imageTag": "20261104091116_0cdb2c7", "buildUri": "vstfs:///Build/Build/104076", "buildId": "104076", "sourceCommit": "0cdb2c73388bbfedad2ae8ccdc57d9e81ecd085f", "sourceBranch": "main", "releaseDate": "2026-11-04T09:14:45Z" }
